import { colors } from '../../colors';
var pencilBanner = {
  bgColor: colors.lightPink,
  textColor: colors.lead,
  textColorDark: colors.lead,
  textColorLight: colors.white
};
export default pencilBanner;